import { AnalyticsPlugin, TrackProperties } from './analytics-plugin.types';

import { getLogger } from '@/logger/logger';

const logger = getLogger(
  'LocalAnalytics',
);

export class LocalAnalytics implements AnalyticsPlugin {
  track(eventName: string, properties?: TrackProperties) {
    logger.info(`[LocalAnalytics] ${eventName}`, { eventName, properties });
  }

  trackCharge(amount: number, properties?: TrackProperties): void {
    logger.info('[LocalAnalytics] trackCharge', {
      amount,
      ...properties,
    });
  }

  async identify(userId: string, userProperties?: TrackProperties): Promise<void> {
    if (userProperties) {
      logger.info('[LocalAnalytics] identify', { userId });
    }
  }

  async getCurrentSessionId(): Promise<string | undefined> {
    return undefined;
  }
}
